module.exports = new __parcel__URL__("AvalancheLogo.ad53a0d0.svg").toString();